export default "__VITE_ASSET__COzFTmzi__"